/**
 * AuditoriaPage (`/admin/auditoria`, RF-ADM-02, RN-GLOBAL-003) — consulta ao
 * histórico append-only de eventos (login, edição, exportação, download).
 *
 * Só admin alcança a rota (guarda no App.tsx + backend valida o grupo). Filtro
 * por tipo. Nenhum dado pessoal de titular é exibido — apenas metadados de
 * operação (RN-M11-001).
 */

import { useState } from 'react';
import { useAuditoria } from '../hooks/useAuditoria';
import { TipoEvento } from '../services/auditoriaApi';

const TIPOS: readonly TipoEvento[] = ['login', 'edicao', 'exportacao', 'download', 'usuario_excluido', 'mfa_redefinido'];

/** Rótulo em palavras dos tipos novos (ADR-052); os antigos seguem com o nome do contrato. */
const ROTULO: Partial<Record<TipoEvento, string>> = {
  usuario_excluido: 'usuário excluído',
  mfa_redefinido: 'autenticador redefinido',
};

export function AuditoriaPage(): JSX.Element {
  const [tipo, setTipo] = useState<TipoEvento | ''>('');
  const { data, isLoading, isError } = useAuditoria(tipo ? { tipo } : {});

  return (
    <div>
      <h1 className="page-title">Auditoria</h1>
      <p className="page-subtitle">
        Histórico append-only de eventos do sistema. Somente leitura (RN-GLOBAL-003).
      </p>

      <section className="card">
        <div className="form-inline">
          <label className="field">
            <span>Tipo de evento</span>
            <select
              value={tipo}
              onChange={(ev) => setTipo(ev.target.value as TipoEvento | '')}
              aria-label="Filtrar por tipo de evento"
            >
              <option value="">Todos</option>
              {TIPOS.map((t) => (
                <option key={t} value={t}>
                  {ROTULO[t] ?? t}
                </option>
              ))}
            </select>
          </label>
        </div>

        {isLoading && <p className="muted">Carregando auditoria…</p>}
        {isError && <p className="notice">Não foi possível carregar a auditoria.</p>}
        {data && data.data.length === 0 && <p className="muted">Nenhum evento encontrado.</p>}
        {data && data.data.length > 0 && (
          <table className="table">
            <thead>
              <tr>
                <th>Data/hora</th>
                <th>Tipo</th>
                <th>Usuário</th>
                <th>IP</th>
                <th>Recurso</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((e) => (
                <tr key={e.id}>
                  <td>{e.timestamp}</td>
                  <td>{ROTULO[e.tipo] ?? e.tipo}</td>
                  <td>{e.usuarioId}</td>
                  <td>{e.ip}</td>
                  <td>{e.recurso}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
}
